import { makeStyles } from '@mui/styles';
import Peek from 'apollo-react/components/Peek';
import Info from 'apollo-react-icons/Info';
import React from 'react';

import ChangesTable from './ChangesTable';

const useStyles = makeStyles({
  root: {
    cursor: 'pointer',
    position: 'relative',
    pointerEvents: 'auto',
  },
  tooltip: {
    backgroundColor: '#fff',
    maxWidth: 'none',
  },
});

const ControlChangesIcon = ({ id }) => {
  const classes = useStyles();

  return (
    <Peek
      className={classes.root}
      classes={{ tooltip: classes.tooltip }}
      placement="left-end"
      anchor={<Info color="primary" />}
      content={<ChangesTable id={id} />}
    />
  );
};

export default ControlChangesIcon;
